module.exports = __webpack_public_path__ + "img/angle-left-solid.b735719b.svg";